<script setup lang="ts">
    import { SidebarTrigger } from '@/components/ui/sidebar';
    import { useSidebar } from '@/components/ui/sidebar';
    import Card from './ui/card/Card.vue';
    import { computed, ref } from 'vue';
    import AppCustomerSelector from '@/components/AppCustomerSelector.vue';
    import GlobalSearch from '@/components/GlobalSearch.vue';
    import { usePage } from '@inertiajs/vue3';
    import { type SharedData } from '@/types';
    import OnboardingGuide from '@/components/onboarding/OnboardingGuide.vue';
    import { usePermissions } from '@/composables/usePermissions';
    import Permission from '@/enums/Permission';

    const page = usePage<SharedData>();
    const hasMultipleCompanies = computed(() => page.props.auth.has_multiple_companies);
    const isClient = computed(() => page.props.auth.user.is_client);
    const isOnboarded = computed(() => page.props.auth.user.is_onboarded);
    const onboardingSteps = computed(() => page.props.auth.onboarding_steps);
    const selectedCompanyId = computed(() => page.props.auth.user.selected_company_id);

    const onboardingGuideRef = ref<InstanceType<typeof OnboardingGuide> | null>(null);
    const { hasPermission } = usePermissions();
</script>

<template>
    <Card class="rounded-none border-none px-2">
        <header class="flex h-11 items-center">
            <SidebarTrigger />
            <div class="h-full w-full">
                <GlobalSearch v-if="hasPermission(Permission.GLOBAL_SEARCH_SEARCH)" />
            </div>
            <div class="ml-auto flex shrink-0 items-center gap-2.5">
                <OnboardingGuide
                    v-if="
                        ((isClient && !isOnboarded) || onboardingGuideRef?.assistantOpen) &&
                        hasPermission(Permission.ONBOARDING_UPDATE_STATUS)
                    "
                    ref="onboardingGuideRef"
                    :onboarding-steps="onboardingSteps"
                    :company-id="selectedCompanyId"
                />
                <AppCustomerSelector v-if="!isClient || hasMultipleCompanies" />
                <div
                    v-else
                    class="pr-2.5 text-sm"
                >
                    {{ page.props.auth.user.selected_company_name }}
                </div>
            </div>
        </header>
    </Card>
</template>
